class VariantOnlinePlayerDescription extends HTMLElement {
  #onVariantChangedListener;
  #descriptionsMap = {};

  constructor() {
    super();
    this.#onVariantChangedListener = this.#onVariantChanged.bind(this);
  }

  connectedCallback() {
    const formId = this.getAttribute('form');
    const dataScript = document.querySelector(`[data-variant-online-player-descriptions-for="${formId}"]`);

    if (dataScript) {
      try {
        this.#descriptionsMap = JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Failed to parse online player descriptions map', e);
      }
    }

    document.forms[formId]?.addEventListener('variant:change', this.#onVariantChangedListener);
  }

  disconnectedCallback() {
    document.forms[this.getAttribute('form')]?.removeEventListener('variant:change', this.#onVariantChangedListener);
  }

  #onVariantChanged(event) {
    if (!event.detail.variant) {
      this.hidden = true;
      return;
    }

    const description = this.#descriptionsMap[event.detail.variant.id];

    if (description && description.trim() !== '') {
      this.innerText = description;
      this.hidden = false;
    } else {
      this.innerText = '';
      this.hidden = true;
    }
  }
}

if (!window.customElements.get('variant-online-player-description')) {
  window.customElements.define('variant-online-player-description', VariantOnlinePlayerDescription);
}